import React from "react";
import { ArrowDown, ArrowUp, Trash2 } from "lucide-react";
import BlockRenderer from "../shared/blocks/BlockRenderer";

export default function CheatsheetBlockList({
                                                blocks = [],
                                                selectedBlockId,
                                                onSelect,
                                                onDelete,
                                                onMove,
                                                onUpdate,
                                            }) {

    if (blocks.length === 0) {
        return (
            <div className="border rounded-xl p-6 bg-white text-center text-gray-500">
                هنوز بلاکی اضافه نشده است.
            </div>
        );
    }

    return (
        <div className="space-y-4">

            {blocks.map((block, index) => (

                <div
                    key={block.id}
                    className={`border rounded-xl p-4 ${
                        selectedBlockId === block.id
                            ? "border-blue-500 bg-blue-50"
                            : "border-gray-200 bg-white"
                    }`}
                >

                    {/* Header */}

                    <div className="flex justify-between items-center mb-4">

                        <button
                            type="button"
                            className="text-right flex-1"
                            onClick={() => onSelect(block.id)}
                        >
                            <div className="font-semibold">
                                {block.type}
                            </div>

                            <div className="text-xs text-gray-500">
                                {block.id}
                            </div>
                        </button>

                        <div className="flex items-center gap-2">

                            <button
                                type="button"
                                disabled={index === 0}
                                onClick={() => onMove(index, index - 1)}
                                className="p-2 rounded hover:bg-gray-100 disabled:opacity-40"
                            >
                                <ArrowUp size={16}/>
                            </button>

                            <button
                                type="button"
                                disabled={index === blocks.length - 1}
                                onClick={() => onMove(index, index + 1)}
                                className="p-2 rounded hover:bg-gray-100 disabled:opacity-40"
                            >
                                <ArrowDown size={16}/>
                            </button>

                            <button
                                type="button"
                                onClick={() => onDelete(block.id)}
                                className="p-2 rounded text-red-600 hover:bg-red-50"
                            >
                                <Trash2 size={16}/>
                            </button>

                        </div>

                    </div>

                    {/* Block Editor */}

                    <BlockRenderer
                        block={block}
                        onUpdate={(updatedBlock) =>
                            onUpdate({
                                ...block,
                                ...updatedBlock,
                                config: {
                                    ...block.config,
                                    ...(updatedBlock.config || {})
                                }
                            })
                        }
                    />

                </div>

            ))}

        </div>
    );
}